import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./gzmodal.css";
import gzmobile1 from "../../../images/gzmobile1.PNG";
import gzmobile2 from "../../../images/gzmobile2.PNG";

const TUTORIAL_VIDEO_SRC =
  "https://iframe.dacast.com/vod/284d2e1d-0e05-44da-6e2a-be63739a10c7/f752b0a4-8fa0-425c-9e5b-45b79791c6cd";

export const GodzillaTradesModal = ({ show, handleClose: closeModal }) => {
  const [showTutorial, setShowTutorial] = useState(false);

  const handleClose = () => {
    setShowTutorial(false);
    closeModal();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="godzillaModal"
      size="xl"
    >
      <Modal.Body className="p-0 overflow-hidden">
        <div className="gtModal">
          {/* ── LEFT: Hero Panel ── */}
          <div className="gtModal__hero">
            <div className="gtModal__stars" />

            <div className="gtModal__pill">
              <span className="gtModal__dot" />
              <span>Now Live</span>
            </div>

            <h2 className="gtModal__headline">
              WAQAR ZAKA
              <br />
              TRADES
              <span>is now on mobile.</span>
            </h2>

            <p className="gtModal__sub">
              Powerful trading tools, education, and real-time market insights —
              now in your pocket.
            </p>

            {/* Phone mockup */}
            <div className="gtModal__phoneWrap">
              <div className="gtModal__phoneBack">
                <img src={gzmobile1} alt="Market Overview" />
              </div>
              {/* <div className="gtModal__signalBadge">
                <div className="gtModal__signalLbl">▲ Live Signal</div>
                <div className="gtModal__signalTtl">STX/USDT · LONG</div>
                <div className="gtModal__signalNum">+0.58% to TP</div>
              </div> */}
              <div className="gtModal__phone">
                <img src={gzmobile2} alt="Trade Signals" />
              </div>
            </div>
          </div>

          {/* ── RIGHT: Content Panel ── */}
          <div className="gtModal__body">
            {/* Close button */}
            <button
              className="gtModal__close"
              onClick={handleClose}
              aria-label="Close"
            >
              <i className="fa-solid fa-xmark" />
            </button>

            {showTutorial ? (
              <>
                <button
                  className="gtModal__back"
                  onClick={() => setShowTutorial(false)}
                >
                  <i className="fa-solid fa-arrow-left" />
                  Back
                </button>
                <div className="gtModal__videoStage">
                  <div className="gtModal__videoBox">
                    <iframe
                      src={TUTORIAL_VIDEO_SRC}
                      title="Mobile App Tutorial"
                      frameBorder="0"
                      scrolling="no"
                      allow="autoplay; encrypted-media; fullscreen"
                      allowFullScreen
                    />
                  </div>
                </div>
              </>
            ) : (
              <>
            <h3 className="gtModal__title">
              The <span className="gtModal__accent">Waqar Zaka Trades</span> app
              is now live on App Store &amp; Play Store.
            </h3>

            <p className="gtModal__lede">
              Access trading tools, education, and real-time market insights
              right from your phone.
            </p>

            {/* Features grid */}
            <div className="gtModal__features">
              {[
                { icon: "fa-chart-line", label: "Waqar Zaka Trades" },
                { icon: "fa-clock", label: "Market Updates" },
                { icon: "fa-play-circle", label: "Educational Videos" },
                { icon: "fa-circle-dot", label: "Live Trading Sessions" },
                { icon: "fa-shield-halved", label: "Exclusive Content" },
                { icon: "fa-ellipsis", label: "And much more" },
              ].map(({ icon, label }) => (
                <div className="gtModal__feat" key={label}>
                  <div className="gtModal__featIc">
                    <i className={`fa-solid ${icon}`} />
                  </div>
                  {label}
                </div>
              ))}
            </div>

            {/* Login callout */}
            <div className="gtModal__callout">
              <div className="gtModal__calloutIc">
                <i className="fa-solid fa-lock" />
              </div>
              <div>
                <b>Login with your waqarzaka.net account</b>
                <p>
                  Use the same email and password you already use here — no new
                  signup needed.
                </p>
              </div>
            </div>

            {/* Store buttons */}
            <div className="gtModal__stores">
              <a
                className="gtModal__storeBtn"
                href="https://apps.apple.com/us/app/waqar-zaka/id6763535854"
              >
                <i className="fa-brands fa-apple gtModal__storeIc" />
                <div className="gtModal__storeLbls">
                  <small>Download on the</small>
                  <b>App Store</b>
                </div>
              </a>
              <a
                className="gtModal__storeBtn gtModal__storeBtn--primary"
                href="https://play.google.com/store/apps/details?id=com.godzillaapp.wz"
              >
                <i className="fa-brands fa-google-play gtModal__storeIc" />
                <div className="gtModal__storeLbls">
                  <small>GET IT ON</small>
                  <b>Google Play</b>
                </div>
              </a>
            </div>

            <button
              type="button"
              className="gtModal__tutorialBtn"
              onClick={() => setShowTutorial(true)}
            >
              <i className="fa-solid fa-circle-play" />
              Mobile App Tutorial
            </button>

            {/* QR row */}
            {/* QR row - two codes */}
            <div className="gtModal__qrRow">
              <div className="gtModal__qrItem">
                <img
                  src="/qr-code-ios.svg"
                  alt="App Store QR"
                  className="gtModal__qrImg"
                />
                <div className="gtModal__qrTxt">
                  <i className="fa-brands fa-apple" />
                  <b>App Store</b>
                  <small>iPhone & iPad</small>
                </div>
              </div>

              <div className="gtModal__qrDivider" />

              <div className="gtModal__qrItem">
                <img
                  src="/qr-code-android.svg"
                  alt="Play Store QR"
                  className="gtModal__qrImg"
                />
                <div className="gtModal__qrTxt">
                  <i className="fa-brands fa-google-play" />
                  <b>Google Play</b>
                  <small>Android</small>
                </div>
              </div>
            </div>
              </>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
